module.exports = __webpack_public_path__ + "images/bjpk10c.e5cc.png";